var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/toggle/star_half_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/toggle/star_half_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9379 7.09126L22.7242 7.68016C23.9581 7.7783 24.4488 9.32065 23.5094 10.1339L18.3636 14.5926L19.906 21.2247C20.1864 22.4305 18.8824 23.384 17.8168 22.739L11.9979 19.2197L6.17912 22.725C5.1135 23.37 3.80952 22.4165 4.08995 21.2107L5.63229 14.5926L0.486479 10.1339C-0.452947 9.32065 0.051819 7.7783 1.28569 7.68016L8.05797 7.10528L10.708 0.851793C11.1847 -0.283931 12.8112 -0.283931 13.2879 0.851793L15.9379 7.09126ZM11.9966 3.5579V16.5977L17.2827 19.7945L15.8805 13.7934L20.5356 9.7553L14.3943 9.22249L11.9966 3.5579Z",
    fill: "#555893"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star_half.0f85d955.svg";
export { ForwardRef as ReactComponent };